var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingSliders = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.699219 4.3501C0.699219 4.81423 0.883593 5.25935 1.21178 5.58753C1.53997 5.91572 1.98509 6.1001 2.44922 6.1001C2.91335 6.1001 3.35847 5.91572 3.68666 5.58753C4.01484 5.25935 4.19922 4.81423 4.19922 4.3501C4.19922 3.88597 4.01484 3.44085 3.68666 3.11266C3.35847 2.78447 2.91335 2.6001 2.44922 2.6001C1.98509 2.6001 1.53997 2.78447 1.21178 3.11266C0.883593 3.44085 0.699219 3.88597 0.699219 4.3501V4.3501Z",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.29297 10.6499C5.29297 10.8797 5.33823 11.1073 5.42618 11.3196C5.51413 11.5319 5.64303 11.7248 5.80553 11.8873C5.96803 12.0498 6.16095 12.1787 6.37327 12.2667C6.58559 12.3546 6.81316 12.3999 7.04297 12.3999C7.27278 12.3999 7.50034 12.3546 7.71266 12.2667C7.92498 12.1787 8.1179 12.0498 8.28041 11.8873C8.44291 11.7248 8.57181 11.5319 8.65976 11.3196C8.7477 11.1073 8.79297 10.8797 8.79297 10.6499C8.79297 10.4201 8.7477 10.1925 8.65976 9.98021C8.57181 9.76789 8.44291 9.57497 8.28041 9.41247C8.1179 9.24996 7.92498 9.12106 7.71266 9.03311C7.50034 8.94517 7.27278 8.8999 7.04297 8.8999C6.81316 8.8999 6.58559 8.94517 6.37327 9.03311C6.16095 9.12106 5.96803 9.24996 5.80553 9.41247C5.64303 9.57497 5.51413 9.76789 5.42618 9.98021C5.33823 10.1925 5.29297 10.4201 5.29297 10.6499V10.6499Z",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.19922 4.3501H13.2992",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.785156 10.6499H5.29176",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.79297 10.6499H13.2996",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSettingSliders;